import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import { setClient } from "../../redux/clientSlice";
import { openClientModal } from "../../redux/modalSlice";

const ClientMedia = ({ clients }) => {
  const dispatch = useDispatch();
  return (
    <>
      {clients &&
        clients.map((item) => {
          return (
            <div className="media-client" key={item.id}>
              <div className="media-body">
                <h4>{item.name}</h4>
                <p>{item.email}</p>
              </div>
              <Link to="#" className="edit">
                <Icon
                  icon="carbon:edit"
                  onClick={() => {
                    dispatch(openClientModal());
                    dispatch(setClient(item));
                  }}
                ></Icon>
              </Link>
            </div>
          );
        })}
    </>
  );
};

export default ClientMedia;
